import * as actions from './actionsTypes';

const initialData = {
  loading: false,
  saveLoader: false,
  auroraDivisionLength: 0,
  auroraDivision: [],
  auroraDivisionError: "",
  formError: "",
}

export default function auroraDivisionReducer(state = initialData, action){
  switch (action.type) {
    case actions.LOADING_AURORA_DIVISION:
      return {...state, loading: action.payload}
    case actions.SAVE_LOADER_AURORA_DIVISION:
      return {...state, saveLoader: action.payload}
    case actions.GET_AURORA_DIVISION:
      return {...state, auroraDivision: action.payload.auroraDivision, auroraDivisionLength: action.payload.auroraDivisionLength}
    case actions.FORM_FAIL:
      return { ...state, formError: action.payload };
    case actions.AURORA_DIVISION_FAIL:
      return { ...state, auroraDivisionError: action.payload };
    default:
      return {...state};
  }
}